import "./style.css";

export default class Hamburger {
  static selector = ".hamburger";

  constructor(block) {
    this.block = block;
  }
}
